import Image, { StaticImageData } from "next/image";

type Logo = React.FC<React.SVGProps<SVGElement>> | StaticImageData;

interface LogoProps {
  logo: Logo;
  className?: string;
  style?: React.CSSProperties;
}

function Logo({ logo, className = "", style = {} }: LogoProps) {
  if (typeof logo === "function") {
    const Logo = logo as React.FC<React.SVGProps<SVGElement>>;
    return <Logo id="logo" className={className} style={style} />;
  } else {
    return (
      <Image
        id="logo"
        src={(logo as StaticImageData).src}
        alt="Logo"
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
    );
  }
}

export default Logo;
export type { Logo };
